import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    minHeight: 60,
    width: "100%",
    fontWeight: 700,
  },
  paddingBottom2: {
    paddingBottom: theme.spacing(2),
  },
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginBottom: theme.spacing(1),
  },
}));

export default useStyles;
